import { render, staticRenderFns } from "./EmployerFileUpload.vue?vue&type=template&id=797a4a8a&scoped=true"
import script from "./EmployerFileUpload.vue?vue&type=script&lang=js"
export * from "./EmployerFileUpload.vue?vue&type=script&lang=js"
import style0 from "./EmployerFileUpload.vue?vue&type=style&index=0&id=797a4a8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a4a8a",
  null
  
)

export default component.exports